import { c as _c } from "react/compiler-runtime";
import type { GraphOperationUpdateSettings, PlaybookSettings } from '@onefootprint/request-types/dashboard';
import type { ReactNode } from 'react';
import SettingsDefaultForm from './components/settings-default-form';
import SettingsDocumentForm from './components/settings-document-form';
type SettingsFormProps = {
  playbook: PlaybookSettings;
  onSubmit?: (data: Omit<GraphOperationUpdateSettings, 'kind'>) => Promise<void>;
  setIsFormDirty: (isDirty: boolean) => void;
  modernize?: ReactNode;
};
const SettingsForm = t0 => {
  const $ = _c(10);
  const {
    playbook,
    onSubmit,
    setIsFormDirty,
    modernize
  } = t0;
  if (playbook.kind === "document") {
    let t1;
    if ($[0] !== modernize || $[1] !== onSubmit || $[2] !== playbook || $[3] !== setIsFormDirty) {
      t1 = <SettingsDocumentForm playbook={playbook} onSave={onSubmit} setIsFormDirty={setIsFormDirty} saveError={null} modernize={modernize} />;
      $[0] = modernize;
      $[1] = onSubmit;
      $[2] = playbook;
      $[3] = setIsFormDirty;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    return t1;
  }
  let t1;
  if ($[5] !== modernize || $[6] !== onSubmit || $[7] !== playbook || $[8] !== setIsFormDirty) {
    t1 = <SettingsDefaultForm playbook={playbook} onSave={onSubmit} setIsFormDirty={setIsFormDirty} saveError={null} modernize={modernize} />;
    $[5] = modernize;
    $[6] = onSubmit;
    $[7] = playbook;
    $[8] = setIsFormDirty;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
};
export default SettingsForm;